export {
  SERVICE_PART_STATUSES,
  SERVICE_PART_CANCELLED_STATUS,
  SERVICE_PART_INSTALLED_STATUS,
  COUNTED_SERVICE_PART_STATUSES,
  SERVICE_PART_RETURNED_STATUS,
  BILLABLE_SERVICE_PART_STATUSES,
  REMOVABLE_SERVICE_PART_STATUSES,
  SERVICE_PART_REMOVER_ROLES,
  REMOVE_REASON_MIN_LENGTH,
  REMOVE_REASON_MAX_LENGTH,
  isCountedServicePartStatus,
  isBillableServicePartStatus,
  isRemovedServicePartStatus,
  isRemovableServicePartStatus,
  canRemoveServicePartsRole,
  normalizeRemoveReason,
  buildRemovalNote,
  appendRemovalNote,
} from './servicePartStatus';
export type { RemovalNoteInput } from './servicePartStatus';
export {
  STAND_IN_ID_PREFIX,
  STAND_IN_STALE_AFTER_MS,
  dropSupersededStandIns,
  isPendingStandIn,
  isStaleStandIn,
  standInState,
} from './pendingStandIn';
export type { StandInState } from './pendingStandIn';
export {
  DUPLICATE_LINE_WINDOW_MS,
  findDuplicatePartLines,
  toDuplicateCheckLine,
} from './duplicatePartLines';
export type { DuplicateCheckLine, DuplicatePartLineGroup } from './duplicatePartLines';
